import { render } from "./Documenti.vue?vue&type=template&id=651fb5ed&scoped=true&ts=true"
import script from "./Documenti.vue?vue&type=script&lang=ts"
export * from "./Documenti.vue?vue&type=script&lang=ts"

import "./Documenti.vue?vue&type=style&index=0&id=651fb5ed&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_mmx/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651fb5ed"]])

export default __exports__